export const WALLET_PATH = '/api/v1/me/wallet';

export function resourceGroup(path) {
  const route = path.split('?')[0];
  if (route === '/api/v1/tasbeeh/shields') return 'shields';
  if (route === WALLET_PATH) return 'wallet';
  if (route === '/api/v1/store/inventory' || route.startsWith('/api/v1/store/sticker-packs/available')) return 'inventory';
  if (/^\/api\/v1\/talents\/(catalog|categories)$/.test(route)) return 'talent-catalog';
  if (/\/cosmetics(?:\/|$)|\/profiles\/[^/]+\/frame$|\/store\/(reaction-assets|profile-theme)\//.test(route)) return 'cosmetics';
  if (/^\/api\/v1\/store\/tools/.test(route)) return 'tools';
  if (/^\/api\/v1\/store\//.test(route)) return 'store';
  if (/^\/api\/v1\/profiles(?:\/|$)/.test(route)) return 'profiles';
  if (/^\/api\/v1\/(posts|teams)(?:\/|$)/.test(route)) return 'posts';
  if (/^\/api\/v1\/(talents|me\/(talents|missions|prayers|adhkar|tasbeeh|quran-progress|daily-plan))/.test(route)) return 'progress';
  return 'other';
}

// Only the personal balance summary is session cached. Team wallet reads still
// go through the server's membership check; ledgers and payment requests stay live.
export function pageCachePolicy(path) {
  const route = path.split('?')[0];
  if (route === '/api/v1/profiles/me/media-review') return null;
  if (route === '/api/v1/tasbeeh/shields') return { maxAge: 5 * 60 * 1000, persist: true };
  if (route === WALLET_PATH) return { maxAge: Infinity, persist: false };
  if (!route.startsWith('/api/v1/')) return null;
  if (/\/(auth|admin|access|moderation|reports|report-replies|restrictions|wallet|wallets|transactions|purchases|conversations|messages|chat|notifications|realtime|media|search|maintenance|saraha|user-notes|games|polls|quizzes|attempts)(\/|$)/.test(route)) return null;
  if (/\/(manage|permissions|availability|live|presence|engagement|comments|replies|reactions|achievement-point|sessions|daily-quizzes|mission-energy)(\/|$)/.test(route)) return null;
  if (/^\/api\/v1\/teams\/[^/]+\/posts$/.test(route)) return { maxAge: 60000, persist: false };
  if (route === '/api/v1/posts/feed' || route === '/api/v1/me/team' || /^\/api\/v1\/teams(?:\/|$)/.test(route)) return null;
  const catalog = /^\/api\/v1\/(talents\/(catalog|categories)|islamic-figures(?:\/[^/]+)?|store\/(sections|items|(?:frames|sticker-packs|reaction-packs|profile-themes)\/config))$/.test(route);
  const progress = /^\/api\/v1\/me\/(talents|missions|prayers|adhkar|tasbeeh|quran-progress|daily-plan)/.test(route);
  const cosmetic = ['cosmetics', 'inventory'].includes(resourceGroup(route));
  return { maxAge: catalog || cosmetic ? 5 * 60 * 1000 : 60 * 1000, persist: catalog || progress };
}

// Unknown writes remain conservative. Known everyday actions invalidate only
// their dependencies, so a reaction or frame change cannot discard the wallet.
export function changedGroups(path, body) {
  const route = path.split('?')[0];
  if (/^\/api\/v1\/(auth|realtime|chat|conversations|messages|notifications)(\/|$)/.test(route)) return [];
  if (/^\/api\/v1\/me\/(notifications|push-devices)(\/|$)/.test(route)) return [];
  if (route.startsWith('/api/v1/admin/tasbeeh/shields/')) return ['shields'];
  if (route.startsWith('/api/v1/admin/profile-media-reviews/') || /\/admin\/profiles\/[^/]+\/media/.test(route)) return ['profiles', 'posts'];
  if (route.startsWith('/api/v1/store/sticker-packs/available/')) return ['inventory'];
  if (/^\/api\/v1\/quizzes\/[^/]+\/tickets$/.test(route)) return ['tools', 'posts'];
  if (route === '/api/v1/store/purchases') return ['wallet', 'inventory', 'cosmetics'];
  if (route === '/api/v1/store/active-item' || route.startsWith('/api/v1/me/cosmetics/')) return ['cosmetics', 'profiles'];
  if (route.startsWith('/api/v1/store/tools/')) return route.endsWith('/purchase') ? ['wallet', 'tools', 'progress'] : ['tools', 'progress'];
  if (route.startsWith('/api/v1/store/')) return ['store', 'inventory', 'cosmetics', 'profiles'];
  if (route.startsWith(`${WALLET_PATH}/`)) return /\/(transfers|exchanges)$|\/pay$/.test(route) ? ['wallet'] : [];
  if (/^\/api\/v1\/(posts|comments)(?:\/|$)/.test(route)) {
    // Comment gifts debit the same wallet as store purchases.
    if (route.endsWith('/achievement-point')) return ['posts', 'profiles', 'progress'];
    return body?.giftAmount || body?.giftCurrency ? ['posts', 'profiles', 'progress', 'wallet'] : ['posts', 'profiles', 'progress'];
  }
  if (/^\/api\/v1\/profiles(?:\/|$)/.test(route)) return ['profiles', 'cosmetics'];
  if (/^\/api\/v1\/daily-quizzes\/[^/]+\/answer$/.test(route)) return ['wallet', 'progress'];
  if (route.startsWith('/api/v1/me/mission-energy/')) return ['progress'];
  if (resourceGroup(route) === 'progress') return /^\/api\/v1\/me\/missions\/[^/]+\/claim$/.test(route) ? ['progress', 'wallet', 'profiles'] : ['progress', 'profiles'];
  return null;
}
